/**
 * GroupPay Payment status codes
 * https://onyxpayments.atlassian.net/wiki/spaces/PION/pages/35160086/Payment+Statuses
 */
export enum PaymentStatus {
  READY = <any>'ready',
  PENDING = <any>'pending',
  INVOICED = <any>'invoiced',
  INVOICE_REJECTED = <any>'invoice-rejected',
  FUNDED = <any>'funded',
  PAY_SENT = <any>'pay-sent',
  PAY_REJECTED = <any>'pay-rejected',
  REQUESTED = <any>'requested',
  ERROR = <any>'error',
  REQUEST_REJECTED = <any>'request-rejected',
  RESENT_REQUEST = <any>'resent-request',
  PAID_DIRECT = <any>'paid-direct',
  CANCELLED = <any>'cancelled',
  PENDING_WF_APPROVAL = <any> 'pending-wf-approval',
  REJECTED_WF_APPROVAL = <any> 'wf-rejected',

  READY_TO_INITIATE = <any>'ready-to-initiate',

  PAID = <any>'paid',
  UNPAID = <any>'unpaid',
  PARTIAL = <any>'partial',
  CHECK_STOPPED = <any>'check-stopped',
  PAY_CLEARED = <any>'pay-cleared',
  PAY_REISSUED = <any>'pay-reissued'
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-status.enum.ts